import React, { useState } from 'react';
import { performanceVideos } from '../data/mock';
import { Button } from '../components/ui/button';

export const Performances = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const categories = ['All', 'Traditional Repertoire', 'Abhinaya', 'Live Performances'];
  
  const filteredVideos = selectedCategory === 'All' 
    ? performanceVideos 
    : performanceVideos.filter(video => video.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-ivory to-cream py-20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 fade-in">
          <h1 className="text-4xl md:text-6xl font-bold text-maroon mb-4">Performance Videos</h1>
          <p className="text-lg text-maroon-dark max-w-2xl mx-auto">
            Explore a collection of performances showcasing the beauty and grace of Bharatanatyam
          </p>
          <div className="w-24 h-1 bg-gold mx-auto mt-6"></div>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12 fade-in">
          {categories.map((category) => (
            <Button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-maroon text-ivory hover:bg-maroon/90'
                  : 'bg-white text-maroon border-2 border-maroon hover:bg-maroon hover:text-ivory'
              }`}
            >
              {category}
            </Button>
          ))}
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {filteredVideos.map((video, index) => (
            <div 
              key={video.id} 
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative pb-[56.25%] bg-maroon-light">
                <iframe
                  src={video.videoUrl}
                  title={video.title}
                  className="absolute top-0 left-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-gold text-maroon text-xs font-semibold rounded-full mb-3">
                  {video.category}
                </span>
                <h3 className="text-xl font-semibold text-maroon mb-2">{video.title}</h3>
                <p className="text-maroon-dark text-sm leading-relaxed">{video.description}</p>
              </div>
            </div>
          ))}
        </div>

        {filteredVideos.length === 0 && (
          <div className="text-center py-12">
            <p className="text-maroon-dark text-lg">No videos found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};
